/**
 * Shared size for every history dialog (ad, campaign, creative).
 *
 * Width is the MUI xl paper (1536), the same size as the Deals ads modal and
 * the FTA location editor, capped by the viewport. Height still matches the
 * Impersonation modal's white card: a 650px table plus a 72px title, 24px under
 * the table, and a 48.8px close bar (8px padding, a 32.8px button, 8px padding).
 */
const IMPERSONATION_TABLE_HEIGHT = 650;
const TITLE_HEIGHT = 24 + 28 + 20;
const SPACE_UNDER_TABLE = 24;
const BUTTON_HEIGHT = 8 + 14 * 1.2 + 8;
const CLOSE_BAR_HEIGHT = 8 + BUTTON_HEIGHT + 8;

export const HISTORY_DIALOG_WIDTH = 1536;
export const HISTORY_DIALOG_HEIGHT =
    IMPERSONATION_TABLE_HEIGHT + TITLE_HEIGHT + SPACE_UNDER_TABLE + CLOSE_BAR_HEIGHT;

/** MUI Dialog props. Width is the xl paper. Height matches the Impersonation card when the viewport is tall enough. */
export const historyDialogProps = {
    maxWidth: false,
    PaperProps: {
        sx: {
            width: `min(${HISTORY_DIALOG_WIDTH}px, calc(100vw - 64px))`,
            maxWidth: 'calc(100vw - 64px)',
            // 100vh, not the padded dialog box, so a short window can still reach the Impersonation card.
            height: `min(${HISTORY_DIALOG_HEIGHT}px, 100vh)`,
            maxHeight: '100vh',
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
        },
    },
};

/**
 * DialogContent layout so the history body uses the paper height down to the Close bar.
 * The panes scroll inside that space instead of leaving a gap above Close.
 */
export const historyDialogContentSx = {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
};
